export class Group {
  constructor(
    public id: string,
    public name: string,
    public inviteToken: string,
    public inviteActive: boolean,
    public createdAt: string,
    public ownerUserId: string,
    public description?: string,
    public memberCount: number = 0,
    public projectCount: number = 0,
  ) {}
}
